export const UNEXPECTED_ERROR = 'Unexpected error';

function getErrorMessage(e) {
    var rjs = e && e.responseJSON;
    var jsError = rjs && rjs.ErrorMessage;

    console.error(e);

    if (jsError) {
        return jsError;
    }

    if (e && e.message) {
        return e.message;
    }

    if (e && e.status) {
        return 'Request failed with error code ' + e.status;
    }

    return 'An unexpected error occurred.';
}

export function handleError(e, prefix) {
    const p = prefix ? prefix + ' ' : '';

    return {
        error: p + getErrorMessage(e),
    };
}
